import type { FaireProductEntity } from "../../entity_types/product";

export const p_3txpkmd7ya: FaireProductEntity = {
  token: "p_3txpkmd7ya",
  type: "product",
  name: "Miss Sparkling Mommy and Me Lace Bow Knit Sweater",
  brandToken: "b_erg8vzmjsk",
  brandName: "Miss Sparkling",
  imageUrl:
    "https://cdn.faire.com/fastly/7c6d0f9ff3cdfb61eabe15c4421fe046eb7b5760513051d6a0cfc18305c7d547.jpeg",
  galleryImageUrls: [],
  priceDollars: 562.03,
  description:
    "-Identical delicate white lace bow appliqué on the front, creating an adorable coordinated look for mom and daughter.\n-Thick ribbed knit fabric that is soft, warm, and breathable, perfect for fall and winter layering.\n-Ideal for family photoshoots, holiday gatherings, casual outings, or as a thoughtful gift for mother-daughter pairs.\n",
  tags: [],
  msrpDollars: 1124.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:43.274Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
